import type { AmplitudeGlobalKeys } from '@/tracking/amplitude/amplitude-properties.types';
import { removeNulls } from '@/tracking/amplitude/utils';
import type { EnrichmentPlugin, Event } from '@amplitude/analytics-types';

type AmplitudeGlobalContextSnapshot = Partial<AmplitudeGlobalKeys>;

let snapshot: AmplitudeGlobalContextSnapshot = {};

export const setAmplitudeGlobalContextSnapshot = (next: AmplitudeGlobalContextSnapshot) => {
    snapshot = next;
};

export const createCasinoEventContextEnrichmentPlugin = (): EnrichmentPlugin => {
    return {
        name: 'casino-event-context',
        type: 'enrichment',
        execute: async (event: Event) => {
            const currentSnapshot = snapshot;
            const currentEventProps = (event.event_properties ?? {}) as Record<string, unknown>;

            event.event_properties = removeNulls({
                ...currentSnapshot,
                ...currentEventProps
            });

            return event;
        }
    };
};
